import { colors } from "@material-ui/core";
export default {
    action: {
        active: colors.blueGrey[600],
    },
    background: {
        default: colors.common.white,
        dark: "#f4f6f8",
        paper: colors.common.white,
        light: "#f2f2f2",
    },
    primary: {
        main: "#262626",
    },
    secondary: {
        main: "#f2f2f2",
    },
    text: {
        primary: "#000",
        secondary: "#999999",
        contrast: "#FFF",
    },
    border: {
        main: "#D9D9D9",
    },
    status: {
        confirmed: {
            border: colors.green[500],
            background: colors.green[50],
            text: colors.green[500],
        },
        pending: {
            border: "#af903b",
            background: "#fcf7e6",
            text: "#af903b",
        },
        cancelled: {
            border: colors.grey[700],
            background: colors.grey[100],
            text: colors.grey[900],
        },
    },
    error: {
        main: "#f44336",
    },
};
//# sourceMappingURL=palette.js.map